import router from "@/router";
import config from './config.js';

import i18n from '@/language/index'

function tolink(path) {
	router.push(path)
}

function onBack() {
	router.back()
}

function getimg(img) {
	if (img != "") {
		return config.send_url + "upload/" + img;
	}
}

function setloc(key, value) {
	localStorage.setItem(key, value);
}

function getloc(key) {
	var val = localStorage.getItem(key);
	return val;
}

function sort_ascii(obj) { //签名
	let _sign = "";
	if (JSON.stringify(obj) != '{}') {

		let arr = new Array();
		let num = 0;
		for (let i in obj) {
			arr[num] = i;
			num++;
		}
		let sortArr = arr.sort();
		let str = config.Project;
		for (let i in sortArr) {
			str += sortArr[i] + '=' + obj[sortArr[i]] + '&';
		}

		//去除两侧字符串
		let char = '&'
		str = str.replace(new RegExp('^\\' + char + '+|\\' + char + '+$', 'g'), '');
		str += config.Project;
		const utilMd5 = require('./md5.js');
		_sign = utilMd5(str).toUpperCase();
	}

	return _sign;
}

function abbr(val, start, end, symbol="...") {
  if (val && val.length > 20) {
    let newVal = val.replace(
      val.substring(start, val.length - end),
      symbol
    )
    return newVal
  } else {
    return val
  }
}

function GetQueryString(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	var r = window.location.search.substr(1).match(reg);
	if (r != null) return unescape(r[2]);
	return null;
}

function splitAndTranslate(text) {
  if (!text) return "";
  // 使用正则表达式分割中英文文本，去掉符号部分
  const regex = /([a-zA-Z0-9]+|[\u4e00-\u9fa5]+)/g;
  const parts = text.match(regex);
  
  if (parts) {
    return parts.map(part => {
      if (/^[\u4e00-\u9fa5]+$/.test(part)) {
        return i18n.global.t(part); // 如果是中文部分，调用 t() 方法
      } else {
        return part; // 其他部分直接返回
      }
    }).join('');
  } else {
    return text; // 如果没有匹配到任何内容，直接返回原始文本
  }
}

export default {
	splitAndTranslate,
	tolink,
	getimg,
	setloc,
	getloc,
	sort_ascii,
	abbr,
	GetQueryString,
	onBack
};
